// Data/DataProviders/SkitterBookLivePagesDataProvider.tsx
import React, { createContext, useContext } from "react";
import { useResourceController } from "../Internal/useResourceController";
import { SkitterBookPagesApi } from "../Apis/SkitterBookPagesApi";
import { SkitterPagesResult } from "../../Models/SkitterPagesResult";
import { SkitterbookLivePagesRequest } from '../../Models/SkitterbookLivePagesRequest';
import { delay } from '../../Utils/FetchUtil';

const SkitterBookPagesDataContext = createContext<ReturnType<typeof useResourceController<SkitterPagesResult>> | null>(null);

interface Props {
    request: SkitterbookLivePagesRequest|undefined;
    children: React.ReactNode;
}

export function SkitterBookLivePagesDataProvider({ request, children }: Props) {
    const noopSave = () => Promise.resolve();

    const controller = useResourceController<SkitterPagesResult>(
        async () => {
            await delay(1000); // delay added to ensure DB is updated before any refresh (bodge!!!)
            return SkitterBookPagesApi.LoadLiveAsync(request);
        },
        noopSave,
        [request]
    );

    return (
        <SkitterBookPagesDataContext.Provider value={controller}>
            {children}
        </SkitterBookPagesDataContext.Provider>);
}

export function useSkitterBookLivePages() {
    const ctx = useContext(SkitterBookPagesDataContext);
    if (!ctx) {
        throw new Error("useSkitterBookPages must be used inside SkitterBookLivePagesDataProvider");
    }
    return ctx;
}
